import { FormattedMessage } from "react-intl";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";
import {
  setManageSubgroupsCountAction,
  setManageUsersCountAction,
} from "../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";

export const groupManagement = {
  label: <FormattedMessage id="UserGroup_Management" />,
  path: (tenantName) => `/${tenantName}/admin/groupManagement`,
  searchPlaceHolder: "Search by group name",
  navLinks: (navigate, tenantName, callBack) => [
    {
      key: 1,
      label: "Admin Features",
      path: `${admin.path(tenantName)}`,
      onClick: () => navigate(`${admin.path(tenantName)}`),
    },
    {
      key: 2,
      label: groupManagement.label,
      path: `${groupManagement.path(tenantName)}`,
      onClick: () => {
        navigate(`${groupManagement.path(tenantName)}`);
        callBack();
      },
    },
  ],
  columns: (navigate, tenantName, dispatch) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERGROUPNAME" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row.Name}>
          {row.Name?.length > 25 ? row.Name?.slice(0, 23) + "..." : row.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: "",
      fieldName: "ManageUsers",
      value: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            cursor: "pointer",
          }}
        >
          <span
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(tenantName)}/manageUsers/${
                  row?.UserGroupId
                }`
              );
            }}
          >
            <Tooltip direction="bottom" content="Edit">
              <EditIcon />
            </Tooltip>
          </span>
          <div
            style={{
              borderBottom: "0.1rem solid currentColor",
              lineHeight: "1.4rem",
            }}
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(tenantName)}/manageUsers/${
                  row?.UserGroupId
                }`
              );
            }}
          >
            <FormattedMessage id="USERGROUP_ADDUSERBTN" />({row.UserGroupCount})
          </div>
        </div>
      ),
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: "",
      fieldName: "ManageSubgroups",
      value: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            cursor: "pointer",
          }}
        >
          <span
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(tenantName)}/manageSubgroups/${
                  row?.UserGroupId
                }`
              );
            }}
          >
            <Tooltip direction="bottom" content="Edit">
              <EditIcon />
            </Tooltip>
          </span>
          <div
            style={{
              borderBottom: "0.1rem solid currentColor",
              lineHeight: "1.4rem",
            }}
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(tenantName)}/manageSubgroups/${
                  row?.UserGroupId
                }`
              );
            }}
          >
            <FormattedMessage id="MANAGE_SUBGROUP" />(
            {row?.UserSubGroups?.length})
          </div>
        </div>
      ),
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: "",
      fieldName: "ManageMandatoryLearnings",
      value: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            cursor: "pointer",
          }}
        >
          <span
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(
                  tenantName
                )}/manageMandatoryLearnings/${row?.UserGroupId}`
              );
            }}
          >
            <Tooltip direction="bottom" content="Edit">
              <EditIcon />
            </Tooltip>
          </span>
          <div
            style={{
              borderBottom: "0.1rem solid currentColor",
              lineHeight: "1.4rem",
            }}
            onClick={() => {
              localStorage.setItem("groupName", row?.Name);
              // localStorage.setItem("manageUsersCount", row?.UserGroupCount);
              // localStorage.setItem(
              //   "manageSubgroupsCount",
              //   row?.UserSubGroups?.length
              // );
              dispatch(setManageUsersCountAction(row?.UserGroupCount));
              dispatch(
                setManageSubgroupsCountAction(row?.UserSubGroups?.length)
              );
              navigate(
                `${groupManagement?.path(
                  tenantName
                )}/manageMandatoryLearnings/${row?.UserGroupId}`
              );
            }}
          >
            <FormattedMessage id="MANDATE_CLASS_USERGROUP" />
          </div>
        </div>
      ),
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
  groupManagementColumns: (handleDelete) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERFIRSTNAME" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_LNAME" />,
      fieldName: "LastName",
      value: (row) => row?.LastName,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="USERMANAGE_EMAILID" />,
      fieldName: "EmailId",
      value: (row) => row.EmailId,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="DELETE_TXT" />,
      fieldName: "",
      value: (row) => (
        <Tooltip
          content={<FormattedMessage id="DELETE_TXT" />}
          direction={"bottom"}
        >
          <span
            style={{ display: "flex", justifyContent: "center" }}
            onClick={() => handleDelete(row)}
          >
            <DeleteIcon />
          </span>
        </Tooltip>
      ),
      sort: false,
    },
  ],
  searchGroupManagementColumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERFIRSTNAME" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_LNAME" />,
      fieldName: "LastName",
      value: (row) => row?.LastName,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="USERMANAGE_EMAILID" />,
      fieldName: "EmailId",
      value: (row) => row.EmailId,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="USER_NAME_TEXT" />,
      fieldName: "LoginId",
      value: (row) => row.LoginId,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
  subgroupManagementColumns: (handleDelete) => [
    {
      ID: 1,
      name: <FormattedMessage id="SUBGROUP_NAME" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="DELETE_TXT" />,
      fieldName: "",
      value: (row) => (
        <Tooltip
          content={<FormattedMessage id="DELETE_TXT" />}
          direction={"bottom"}
        >
          <span
            style={{ display: "flex", justifyContent: "center" }}
            onClick={() => handleDelete(row)}
          >
            <DeleteIcon />
          </span>
        </Tooltip>
      ),
      sort: false,
    },
  ],
  searchSubgroupManagementColumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="SUBGROUP_NAME" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
};
